import axios from "axios"
export const createAdvertiser = (aData, token) => {
   return axios.post(process.env.REACT_APP_API_URL + '/advertiserRegister',aData, {
      headers: {
         'Authorization': `${token}`
      }
   });
}